module.exports = __webpack_public_path__ + "res/Roboto-BlackItalic-webfontd41d.eot?2135e78af10078f722cd4614c00e88c9";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-BlackItalic-webfontd41d.eot
// module id = 87
// module chunks = 0